import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeToastMsg } from "../redux/auth/authActions";

function Toast() {
  const dispatch = useDispatch();
  const toastMsg = useSelector((state) => state.auth.toastMsg);
  const toastMsgType = useSelector((state) => state.auth.toastMsgType);

  useEffect(() => {
    setTimeout(() => {
      dispatch(removeToastMsg());
    }, 4000);
    // eslint-disable-next-line
  }, [toastMsg]);

  return (
    <div
      className={`toast-container ${toastMsgType === "error" && "error-toast"}`}
    >
      <p>{toastMsg}</p>
    </div>
  );
}

export default Toast;
